import { Controller }  from '@hotwired/stimulus';

export default class AbilityTestController extends Controller {
  static targets = [
    'answerTextField'
  ];

  static values = {
    tabIndex: Number
  };

  dispatchCompleteAnswersEvent() {
    const event = this.answerTextFieldTargets.every(field => field.value !== '') ? 'completeAnswers' : 'uncompleteAnswers';

    this.dispatch(event, { detail: { tabIndex: this.tabIndexValue } });
  }
}